/**
 * By removing direct apollo/client usage and instead forcing use via this lib
 * we can swap out the implementation of apollo more easily in the future.
 */
import type {
    QueryHookOptions,
    OperationVariables,
    DocumentNode,
    LazyQueryHookOptions,
    MutationHookOptions,
    ApolloQueryResult
} from '@apollo/client';
import {
    useQuery,
    useLazyQuery,
    useMutation,
    ApolloProvider,
    useApolloClient,
    ApolloError,
    ApolloClient,
    NormalizedCacheObject,
    from,
    HttpLink,
    InMemoryCache
} from '@apollo/client';

/** @deprecated */
function customQueryHook<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TData = any,
    TVariables extends OperationVariables = OperationVariables,
    TDocument extends DocumentNode = DocumentNode
>(document: TDocument) {
    const defaultOptions = {};
    return function (baseOptions?: QueryHookOptions<TData, TVariables>) {
        const options = { ...defaultOptions, ...baseOptions };
        return useQuery<TData, TVariables>(document, options);
    };
}

/** @deprecated */
function customLazyQueryHook<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TData = any,
    TVariables extends OperationVariables = OperationVariables,
    TDocument extends DocumentNode = DocumentNode
>(document: TDocument) {
    const defaultOptions = {};
    return function (baseOptions?: LazyQueryHookOptions<TData, TVariables>) {
        const options = { ...defaultOptions, ...baseOptions };
        return useLazyQuery<TData, TVariables>(document, options);
    };
}

/** @deprecated */
function customMutationHook<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TData = any,
    TVariables extends OperationVariables = OperationVariables,
    TDocument extends DocumentNode = DocumentNode
>(document: TDocument) {
    const defaultOptions = {};
    return function (baseOptions?: MutationHookOptions<TData, TVariables>) {
        const options = { ...defaultOptions, ...baseOptions };
        return useMutation<TData, TVariables>(document, options);
    };
}

export {
    /** @deprecated */
    useQuery,
    /** @deprecated */
    useLazyQuery,
    /** @deprecated */
    useMutation,
    /** @deprecated */
    ApolloProvider,
    /** @deprecated */
    useApolloClient,
    /** @deprecated */
    ApolloError,
    /** @deprecated */
    ApolloClient,
    /** @deprecated */
    from,
    /** @deprecated */
    HttpLink,
    /** @deprecated */
    InMemoryCache,
    /** @deprecated */
    type NormalizedCacheObject,
    /** @deprecated */
    type ApolloQueryResult,
    type DocumentNode,
    type OperationVariables,
    customQueryHook,
    customLazyQueryHook,
    customMutationHook
};
